import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonPlPl = {
  brand: {
    logoAlt: 'Logo Safi',
    name: 'Safi',
    vatLabel: 'VAT Safi',
  },
  currencySelectField: {
    groups: {
      other: 'Inne',
      suggested: 'Sugerowane',
    },
  },
  domains: {
    evidence: 'Dowody',
    evidenceLower: 'dowody',
    qualityControl: 'Kontrola jakości',
    qualityControlLower: 'kontrola jakości',
  },
  values: {
    emptyValue: '-',
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
